/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Files_Details_PromptInputs */

const en_us2_builds_files_details_prompt = /** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a file to inspect its metadata and compare it with the baseline build.`)
};

const es_es2_builds_files_details_prompt = /** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un archivo para consultar sus metadatos y compararlo con la compilación de referencia.`)
};

const ru_builds_files_details_prompt = /** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите файл, чтобы просмотреть его метаданные и сравнить их с базовой сборкой.`)
};

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const id_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const ms_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const da_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const de_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const es_mx2_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const fil_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const fr_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const it_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const hu_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const nl_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const no_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const pl_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const pt_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const pt_br2_builds_files_details_prompt = pt_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const ro_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const fi_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const sv_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const vi_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const tr_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const cs_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const bg_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const uk_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const ar_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const hi_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const th_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const ja_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const zh_cn2_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const zh_hant1_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/** @type {(inputs: Builds_Files_Details_PromptInputs) => LocalizedString} */
const ko_builds_files_details_prompt = en_us2_builds_files_details_prompt;

/**
* | output |
* | --- |
* | "Select a file to inspect its metadata and compare it with the baseline build." |
*
* @param {Builds_Files_Details_PromptInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_files_details_prompt = /** @type {((inputs?: Builds_Files_Details_PromptInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Files_Details_PromptInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_files_details_prompt(inputs)
	if (locale === "ms") return ms_builds_files_details_prompt(inputs)
	if (locale === "da") return da_builds_files_details_prompt(inputs)
	if (locale === "de") return de_builds_files_details_prompt(inputs)
	if (locale === "en-US") return en_us2_builds_files_details_prompt(inputs)
	if (locale === "es-ES") return es_es2_builds_files_details_prompt(inputs)
	if (locale === "es-MX") return es_mx2_builds_files_details_prompt(inputs)
	if (locale === "fil") return fil_builds_files_details_prompt(inputs)
	if (locale === "fr") return fr_builds_files_details_prompt(inputs)
	if (locale === "it") return it_builds_files_details_prompt(inputs)
	if (locale === "hu") return hu_builds_files_details_prompt(inputs)
	if (locale === "nl") return nl_builds_files_details_prompt(inputs)
	if (locale === "no") return no_builds_files_details_prompt(inputs)
	if (locale === "pl") return pl_builds_files_details_prompt(inputs)
	if (locale === "pt-BR") return pt_br2_builds_files_details_prompt(inputs)
	if (locale === "pt") return pt_builds_files_details_prompt(inputs)
	if (locale === "ro") return ro_builds_files_details_prompt(inputs)
	if (locale === "fi") return fi_builds_files_details_prompt(inputs)
	if (locale === "sv") return sv_builds_files_details_prompt(inputs)
	if (locale === "vi") return vi_builds_files_details_prompt(inputs)
	if (locale === "tr") return tr_builds_files_details_prompt(inputs)
	if (locale === "cs") return cs_builds_files_details_prompt(inputs)
	if (locale === "bg") return bg_builds_files_details_prompt(inputs)
	if (locale === "ru") return ru_builds_files_details_prompt(inputs)
	if (locale === "uk") return uk_builds_files_details_prompt(inputs)
	if (locale === "ar") return ar_builds_files_details_prompt(inputs)
	if (locale === "hi") return hi_builds_files_details_prompt(inputs)
	if (locale === "th") return th_builds_files_details_prompt(inputs)
	if (locale === "ja") return ja_builds_files_details_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_files_details_prompt(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_files_details_prompt(inputs)
	return ko_builds_files_details_prompt(inputs)
});
export { builds_files_details_prompt as "builds.files.details.prompt" }